import { render, staticRenderFns } from "./detailMember.vue?vue&type=template&id=3f9a74a0&"
import script from "./detailMember.vue?vue&type=script&lang=js&"
export * from "./detailMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports